// eslint-disable-next-line import/no-anonymous-default-export
export default {
  US: {
    name: "United States",
    alpha_2_code: "US",
    country_code: "1",
    zones: [
      "America/New_York",
      "America/Detroit",
      "America/Kentucky/Louisville",
      "America/Kentucky/Monticello",
      "America/Indiana/Indianapolis",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Indiana/Marengo",
      "America/Indiana/Petersburg",
      "America/Indiana/Vevay",
      "America/Chicago",
      "America/Indiana/Tell_City",
      "America/Indiana/Knox",
      "America/Menominee",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/North_Dakota/Beulah",
      "America/Denver",
      "America/Boise",
      "America/Phoenix",
      "America/Los_Angeles",
      "America/Anchorage",
      "America/Juneau",
      "America/Sitka",
      "America/Metlakatla",
      "America/Yakutat",
      "America/Nome",
      "America/Adak",
      "Pacific/Honolulu",
    ],
    default_geocoding_points: {
      name: "Hennepin County",
      lat: 44.9736461,
      lng: -93.25749449999999,
    },
  },
  IN: {
    name: "India",
    alpha_2_code: "IN",
    country_code: "91",
    zones: ["Asia/Kolkata", "Asia/Kolkata"],
    default_geocoding_points: {
      name: "Chandigarh",
      lat: 30.7333,
      lng: 76.7794,
    },
  },
  AE: {
    name: "United Arab Emirates",
    alpha_2_code: "AE",
    country_code: "971",
    zones: ["Asia/Dubai"],
    default_geocoding_points: {
      name: "Dubai",
      lat: 25.2048,
      lng: 55.2708,
    },
  },
};
